import { css } from '@emotion/react';

const getTableHeadCss = css`
  border-bottom: 2px solid var(--cds-color-neutral-stroke-primary-weak);
`;

export default getTableHeadCss;
